import { STATUS_LABELS, STATUS_COLORS } from '../utils/statuses';
export default function StatusBadge({ status }) {
  const color = STATUS_COLORS[status] || { bg: '#f3f4f6', text: '#374151', border: '#d1d5db' };
  return (
    <span style={{ background: color.bg, color: color.text, border: `1px solid ${color.border}`, borderRadius: 20, padding: '3px 12px', fontSize: '0.8rem', fontWeight: 600, whiteSpace: 'nowrap' }}>
      {STATUS_LABELS[status] || status}
    </span>
  );
}
